import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import TeacherWeixinProfile from '@/types/table/teacherWeixinProfile';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface TeacherWeixinProfileData extends TeacherWeixinProfile {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class TeacherWeixinProfileController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<TeacherWeixinProfileData>>(API_CONTEXT + '/app/teacherWeixinProfile/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<TeacherWeixinProfileData>(API_CONTEXT + '/app/teacherWeixinProfile/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/teacherWeixinProfile/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/teacherWeixinProfile/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/teacherWeixinProfile/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/teacherWeixinProfile/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/teacherWeixinProfile/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/teacherWeixinProfile/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/teacherWeixinProfile/deleteBatch', params, httpOptions);
  }
}
